import {Editor} from '@tiptap/react';

export const SET_EDITOR = 'SET_EDITOR';
export const SET_DEBOUNCE_CHANGE_HANDLER = 'SET_DEBOUNCE_CHANGE_HANDLER';
export const EDITOR_MODE = 'EDITOR_MODE';

export enum EditorModeEnum {
    SELECT = 'SELECT',
    EDIT = 'EDIT',
}

export type EditorModeType = EditorModeEnum.EDIT | EditorModeEnum.SELECT | null;

export interface ISetEditorAction {
    type: typeof SET_EDITOR;
    payload: {id: string; editor: Editor};
}

export interface ISetDebounceChangeHandlerAction {
    type: typeof SET_DEBOUNCE_CHANGE_HANDLER;
    payload: {id: string; handler: (updatedContent: string) => void};
}

export interface ISetEditorMode {
    type: typeof EDITOR_MODE;
    payload: {mode: EditorModeType};
}

export type EditorActionTypes = ISetEditorAction | ISetDebounceChangeHandlerAction | ISetEditorMode;
